<template>
	<div class='' style="height:100%;width:100%;margin: 0; padding: 0;">
		<div id="cesiumContainer" v-loading.fullscreen="loading" :element-loading-text="loadingTxt"></div>
		<div id="id_pop"></div>
		<tool-bar :viewer="viewer" :father="this"></tool-bar>
		<div id="id_video" v-show="isShowVideo" :style="{left:video_left,top:video_top}">
			<div id="id_video_play"></div>
		</div>
		<div v-for="item in dataRequest.devList" :id="'div_'+item.devId" class="cls-div-tip" :style="{top:item.top, left:item.left}">
		</div>
	</div>
</template>

<script>
import * as  Cesium from  'cesium/Cesium';
import widgets from 'cesium/Widgets/widgets.css';
import wifiImg from "@/assets/3d/wifi.png";
import pointImg0 from "@/assets/3d/point/point0.png";
import pointImg1 from "@/assets/3d/point/point1.png";
import pointImg2 from "@/assets/3d/point/point2.png";
import pointImg3 from "@/assets/3d/point/point3.png";
import videoImg from "@/assets/3d/point/video.png";

import dev48 from '@/assets/3d/dev-48.png';
import dev49 from '@/assets/3d/dev-49.png';
import dev59 from '@/assets/3d/dev-59.png';
import dev128 from '@/assets/3d/dev-128.png';
import dev129 from '@/assets/3d/dev-129.png';
import dev131 from '@/assets/3d/dev-131.png';
import dev167 from '@/assets/3d/dev-167.png';
import dev168 from '@/assets/3d/dev-168.png';
import dev169 from '@/assets/3d/dev-169.png';
import $ from 'jquery';
import {selectRealSceneData, selectDevRealData} from "@/api/3d/iotReq";
import toolBar from './components/toolBar';
import {listVideo} from "@/api/video/monitor";
import "cyberplayer";

export default {
	name: 'cesiumViewer',
	components:{
        toolBar
    },
    props: {
        mapid: {
            type:Number, 
            defined: 0
        }
    },
	data(){
		return {
			//id: 114,
			isShowVideo: false,
			player: null,
			video_left: 0,
			video_top: 0,
			video_pick_entity: null,
			videoList: [],

			loading:true,
			loadingTxt: '',
			id:null,
            dataRequest : {
				siteId: 114,
				siteName: "颜闸村丰泽园",
				enterpriseName: "荆州市江陵县郝穴镇",
				tileUrl: "http://www.is51.cn:9001/data_cesium/颜闸村/倾斜/tileset.json",
				twoDimenUrl: "http://www.is51.cn:9000/data_cesium/颜闸村/影像/{z}/{x}/{y}.png",
				viewX: -2109972.236535511,
				viewY: 5109465.627192092,
				viewZ: 3171161.404941637,
				heading: 3.7894661189281797,
				pitch: -0.6252599765489384,
				roll: 0,
				height: 50,
				devList: [
					{devId: "1020FF01D3A100A0", x: 112.4373, y: 30.0058, devName: "大棚采集站"},
					{devId: "0007C802D4A100F2", x: 112.43775, y: 30.0066, devName: "气象站"},
					{devId: "1021FF01D4A100F2", x: 112.43785, y: 30.006, devName: "气象采集"}
				]
			},
			devData: {
				devId:"1021FF01D4A100F2",
				devName:"气象采集",
				updateTime:"2020-09-24 16:29:15",
				devState:3,
				realDevList:[
					{"code":168,"name":"空气温度","state":3,"value":"28.1℃"},
					{"code":48,"name":"CO2浓度","state":1,"value":"445.0ppm"},
					{"code":49,"name":"光照度","state":1,"value":"42024.0lux"},
					{"code":59,"name":"PH","state":1,"value":"7.9"},
					{"code":169,"name":"空气湿度","state":1,"value":"60.9%"},
					{"code":170,"name":"土壤温度","state":1,"value":"28.8℃"},
					{"code":171,"name":"土壤湿度","state":1,"value":"12.5%"}
				]
			},
			viewer: null,
			pointHight: 100,  //标签海拔
			pmsg_div: '',
			myPrimitive: null,
			myImageryLayer: null,
			myEventListener: null,
			intervalIOT: null
		}
	},
	created(){
		console.log('mapid',this.mapid)
		this.id=this.mapid
	},
	mounted(){
		this.init();
	},
	methods: {
		init(){
			console.log('----初始化地球----');
			var Cesium = this.Cesium;
			Cesium.Ion.defaultAccessToken='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIwMGU4MDM3Ny05YTRiLTRkYTAtOTM3NS1jMzQwY2U5NzM1NDIiLCJpZCI6MzY5MjgsImlhdCI6MTYwNDM2NDY4Mn0.YPNvh9Di45Rm2L9PojLFIEp_vsgai2msDJCPahE9DBs';
			
			this.viewer = new Cesium.Viewer('cesiumContainer',{
				baseLayerPicker:false,
				timeline:false,
				homeButton:false,
				fullscreenButton:false,
				infoBox:false,
				sceneModePicker:false,
				navigationInstructionsInitiallyVisible:false,
				navigationHelpButton:false,
				geocoder:false,
				animation:false,
				selectionIndicator:false,
				creditsDisplay: false
			});
			this.viewer.cesiumWidget.creditContainer.style.display = 'none';
			this.viewer.scene.postProcessStages.fxaa.enabled = false;
			this.viewer.scene.globe.enableLighting = true;
			this.viewer.scene.globe.depthTestAgainstTerrain = true;

			//加载谷歌地图
			var gog=new Cesium.UrlTemplateImageryProvider({
				url:"http://mt1.google.cn/vt/lyrs=s&hl=zh-CN&x={x}&y={y}&z={z}&s=Gali"})
			this.viewer.imageryLayers.addImageryProvider(gog);
			//单击事件
			this.handlerMouseClickAction();

			var helper = new Cesium.EventHelper();
			let that = this;
			helper.add(this.viewer.scene.globe.tileLoadProgressEvent, function (event) {
				//console.log("----", event);
				that.loadingTxt = '地图正在加载！'+event;
				if (event == 0) {
					that.loading = false;
					console.log("这个是加载最后一个矢量切片的回调");
				}
			});
			if(this.mapid){
				this.initScene();
			}
			
		},

		handlerMouseClickAction(){
			var handler = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);
            var me = this;
			handler.setInputAction(function(movement){	
				var cartesian = me.viewer.camera.pickEllipsoid(movement.position, me.viewer.scene.globe.ellipsoid);
				if(cartesian){
					//将笛卡尔三维坐标转为地图坐标（弧度）
					var cartographic = me.viewer.scene.globe.ellipsoid.cartesianToCartographic(cartesian);
					//将地图坐标（弧度）转为十进制的度数
					var lat=Cesium.Math.toDegrees(cartographic.latitude);
					var lon=Cesium.Math.toDegrees(cartographic.longitude);
					console.log(movement.position, cartesian, cartographic, lon, lat);
				}
				//获取pick的object，如果使用click类型的鼠标操作，则相应的选择pick和pick.position
				var pickOdv = me.viewer.scene.pick(movement.position);
				var pick_entity = (Cesium.defined(pickOdv)) ? pickOdv.id :undefined;
				if(pickOdv && pickOdv.id){
					console.log(pick_entity.id);
					if(pick_entity.ptype == 'video'){ //摄像头
						if(me.isShowVideo){ //关闭
							if(pick_entity == me.video_pick_entity){//same
								me.isShowVideo = false;
								if(me.player){
									me.player.remove();
									me.video_pick_entity = null;
								}
							}else{
								me.video_pick_entity = pick_entity;
								var _url = me.videoList[pick_entity.pindex].rtsp; //'http://hls01open.ys7.com/openlive/3a19b51ea48747a19b6d5add44647b71.hd.m3u8';
								me.baiduMp4(_url);
							}
							
						}else{//打开视频
							me.isShowVideo = true;
							me.video_pick_entity = pick_entity;

							var _url = me.videoList[pick_entity.pindex].rtsp; //'http://hls01open.ys7.com/openlive/3a19b51ea48747a19b6d5add44647b71.hd.m3u8';
							me.baiduMp4(_url);
						}
					}else{// 物联网设备
						$('#div_'+pick_entity.id).toggle();
					}
				}
			},Cesium.ScreenSpaceEventType.LEFT_CLICK);
		},

		initScene(){
			this.clear();
			console.log("----请求站点数据----", this.mapid);
			this.loading = true;
			selectRealSceneData({siteId: this.mapid}).then(res => {
				console.log("----接收后台数据----", res.data.siteName);
				if (res.code === 200) {
					if (res.data) {
						this.dataRequest = res.data;
						this.pointHight = this.dataRequest.height||100;

						//this.showTile(this.dataRequest);
						this.flyTo(this.dataRequest);
						this.showIOT(this.dataRequest.devList);
						this.requestVideoList();
					}
				}else{
					this.loading = false;
				}
			});
		},

        //2维地图
		changeMap2(isLoadMap){
			if(this.myPrimitive){
				this.viewer.scene.primitives.remove(this.myPrimitive);
				this.myPrimitive = null;
			}
			if(isLoadMap){
				if(this.dataRequest.twoDimenUrl){
					console.log('----切换到2d----');
					this.loading = true;
					this.myImageryLayer = this.viewer.imageryLayers.addImageryProvider(
						new Cesium.UrlTemplateImageryProvider({url: this.dataRequest.twoDimenUrl}));
				}
			}else{
				if(this.myImageryLayer){
					this.viewer.imageryLayers.remove(this.myImageryLayer);
					this.myImageryLayer = null;
				}
			}
		},

        //3维地图
		changeMap3(isLoadMap){
			if(this.myImageryLayer){
				this.viewer.imageryLayers.remove(this.myImageryLayer);
				this.myImageryLayer = null;
			}
			if(isLoadMap){
				if(this.dataRequest.tileUrl){
					console.log('----切换到3d----');
					this.loading = true;
					this.myPrimitive = new Cesium.Cesium3DTileset({url: this.dataRequest.tileUrl,
						visibleRange : { max: 22000 },
						dynamicScreenSpaceError : true,
						dynamicScreenSpaceErrorDensity : 0.00278,
						dynamicScreenSpaceErrorFactor : 4.0,
						dynamicScreenSpaceErrorHeightFalloff : 0.25,
						maximumScreenSpaceError : 50,
						maximumNumberOfLoadedTiles : 50000
					});

					var tileSet = this.viewer.scene.primitives.add(this.myPrimitive);
					var me = this;
					this.myPrimitive.allTilesLoaded.addEventListener(function() {
						console.log('----加载村场景 完成----');
						me.loading = false;
					});
				}
			}else{
				if(this.myPrimitive){
					this.viewer.scene.primitives.remove(this.myPrimitive);
					this.myPrimitive = null;
				}
			}
		},

		changeScene(){
			if(this.myPrimitive){ //jia 2d
				this.viewer.scene.primitives.remove(this.myPrimitive);
				this.myPrimitive = null;
				if(this.dataRequest.twoDimenUrl){
					console.log('----切换到2d----');
					this.loading = true;
					this.myImageryLayer = this.viewer.imageryLayers.addImageryProvider(
						new Cesium.UrlTemplateImageryProvider({url: this.dataRequest.twoDimenUrl}));
				}
			}else{  //jia 3d
				if(this.myImageryLayer){
					this.viewer.imageryLayers.remove(this.myImageryLayer);
					this.myImageryLayer = null;
				}

				if(this.dataRequest.tileUrl){
					console.log('----切换到3d----');
					this.loading = true;
					this.myPrimitive = new Cesium.Cesium3DTileset({url: this.dataRequest.tileUrl,
						visibleRange : { max: 22000 },
						dynamicScreenSpaceError : true,
						dynamicScreenSpaceErrorDensity : 0.00278,
						dynamicScreenSpaceErrorFactor : 4.0,
						dynamicScreenSpaceErrorHeightFalloff : 0.25,
						maximumScreenSpaceError : 50,
						maximumNumberOfLoadedTiles : 50000
					});

					var tileSet = this.viewer.scene.primitives.add(this.myPrimitive);
					var me = this;
					this.myPrimitive.allTilesLoaded.addEventListener(function() {
						console.log('----加载村场景 完成----');
						me.loading = false;
					});
				}
			}
    	},
		
		showTile(data){
			console.log('----加载村场景----', data.tileUrl, data.twoDimenUrl);
			if(data.twoDimenUrl){
				this.myImageryLayer = this.viewer.imageryLayers.addImageryProvider(
					new Cesium.UrlTemplateImageryProvider({url: data.twoDimenUrl}));
			}else if(data.tileUrl){
				this.myPrimitive = new Cesium.Cesium3DTileset({
					url: data.tileUrl,
					visibleRange : { max: 22000 },
					dynamicScreenSpaceError : true,
					dynamicScreenSpaceErrorDensity : 0.00278,
					dynamicScreenSpaceErrorFactor : 4.0,
					dynamicScreenSpaceErrorHeightFalloff : 0.25,
					maximumScreenSpaceError : 50,
					maximumNumberOfLoadedTiles : 50000
				});

				var tileSet = this.viewer.scene.primitives.add(this.myPrimitive);

				var me = this;
				this.myPrimitive.allTilesLoaded.addEventListener(function() {
					console.log('----加载村场景 完成----');
					me.loading = false;
				});
			}
		},

		flyTo(data){
			console.log('----前往默认视角----');
			if(data.viewX && data.viewY && data.viewZ){
				var viewPoint = {x: data.viewX, y: data.viewY, z: data.viewZ};
				//Cesium.Cartesian3.fromDegrees(112.43750875265964,30.005589995975487, 100);
				var hcv = {
					destination: viewPoint,
					orientation: {
						heading : data.heading, //Cesium.Math.toRadians(0.0),
						pitch : data.pitch, //Cesium.Math.toRadians(-35.0),
						roll : data.roll
					}
				}
				//viewer.camera.setView(hcv);
				this.viewer.camera.flyTo(hcv);
			}else{
				this.loading = false;
				this.moveToHubei();
			}
		},

		moveToHubei(){
			console.log('----移动地图到湖北----');
			var viewPoint = {x: -2264706.893116936, y: 5430025.26103238, z: 3415803.598998195};
			var hcv = {
				destination: viewPoint,
				orientation: {
					heading : 6.2831853071, 
					pitch : -1.568643548, 
					roll : 0
				}
			}
			this.viewer.camera.flyTo(hcv);
		},

		showIOT(data){	
			console.log('----添加设备标签----');
			for( var i in data){
				console.log(data[i].devId,data[i].x, data[i].y, this.pointHight);
				if(!data[i].x || !data[i].y || (data[i].status == 1) || (data[i].status == '1')){
					continue;
				}
				var entity = this.initPoint(data[i]);
						
				var geometry = Cesium.Cartesian3.fromDegrees(data[i].x, data[i].y, this.pointHight);
				var position = Cesium.SceneTransforms.wgs84ToWindowCoordinates(this.viewer.scene, geometry);
				var _topx = -500;
				var _topy = -500;
				if(position){
					_topx = position.x;
					_topy = position.y;
				}
				data[i].left = _topx;
				data[i].top = _topy;
				// var _html = '<div id="div_'+data[i].devId+'" class="cls-div-tip" style="top:'+_topy+'px;left:'+_topx+'px;">';
				// _html += '</div>';
				// $('#cesiumContainer').append(_html);
			}
			//请求物联网详细信息
			this.requestAllIOT();
			if(this.intervalIOT)
				clearInterval(this.intervalIOT);
			this.intervalIOT = setInterval(this.requestAllIOT,100000);

			var me = this;
			this.myEventListener = function(clock) {
				me.render(data);
			};
			this.viewer.clock.onTick.addEventListener(this.myEventListener);
		},

		initPoint(item){
			var point = this.viewer.entities.add({
				id:item.devId,
				name : item.devName,
				position:Cesium.Cartesian3.fromDegrees(item.x,item.y, this.pointHight),
				ptype: 'dev',
				billboard:{
					image: pointImg1,
					width: 38,
					height: 50,
					scaleByDistance: new Cesium.NearFarScalar(100, 1.0, 1e4, 0.5)//,
					//scale: 1//,//0.6,
					//heightReference : Cesium.HeightReference.RELATIVE_TO_GROUND
				},
				label:{
					text:item.devName,
					font:'14px sans-serif',
					style: Cesium.LabelStyle.FILL_AND_OUTLINE,
					fillColor: Cesium.Color.AQUAMARINE,
					backgroundColor: new Cesium.Color(0, 0, 0, .9),
				//    clampToGround:false,
					//scale: 0.8,
					horizontalOrigin : Cesium.HorizontalOrigin.CENTER,
					verticalOrigin : Cesium.VerticalOrigin.BOTTOM,
					disableDepthTestDistance: 100.0,
					pixelOffset:new Cesium.Cartesian2(0, -30),
					//heightReference : Cesium.HeightReference.RELATIVE_TO_GROUND,
					showBackground:true
				}
			});
			
			//line
			var position1 = Cesium.Cartesian3.fromDegrees(item.x,item.y, this.pointHight);
			var position2 = Cesium.Cartesian3.fromDegrees(item.x,item.y,0);
			this.viewer.entities.add({
				polyline: {
					positions: [position1, position2],
					clampToGround: false,
					//material: Cesium.Color.RED,
					width: 1
				}
			});
			return point;
		},

		requestAllIOT(){
			for(var i in this.dataRequest.devList){
				if(this.dataRequest.devList[i].x && this.dataRequest.devList[i].y){
					this.requestIOTDetailById(this.dataRequest.devList[i].devId);
				}
			}
			
		},

		requestIOTDetailById(devId){
			console.log('----请求物联网信息----', devId);
			selectDevRealData({devId: devId}).then(res => {
				if (res.code === 200) {
					if (res.data) {
						this.updateIOTDetail(res.data);
					}
				}
			}).catch(err =>{
				console.log(err);
				//$('#div_' + devId).hide();
				var _html = '<h4 class="cls-tip-name iot-state-error">未接收到物联信息！</h4>'; 
				$('#div_' + devId).html(_html);
			});
		},

		updateIOTDetail(data){
			var _html = '';
			_html += '<div class="cls-tip-name cls-state-'+data.devState+'" title="物联网设备信息更新的时间">'+data.updateTime+'</div>'; //data[i].devmc
				_html += '<ul class="cls-ul-sblb">';
				this.updateEntity(data.devId, data.devState);
				for(var j in data.realDevList){
						var _state = data.realDevList[j].state;
						var _state_color = 'cls-state-1';
						var _str_state = '';
						switch(_state){
							case 0: _state_color = 'cls-state-0'; _str_state = '离线'; break;
							case 1: _state_color = 'cls-state-1'; _str_state = '正常'; break;
							case 2: _state_color = 'cls-state-2'; _str_state = '异常'; break;
							case 3: _state_color = 'cls-state-3'; _str_state = '紧急'; break;
						}
						var _imgsrc = dev48;
						switch(data.realDevList[j].code){
							case 48:_imgsrc = dev48;break;
							case 49:_imgsrc = dev49;break;
							case 59:_imgsrc = dev59;break;
							case 128:_imgsrc = dev128;break;
							case 129:_imgsrc = dev129;break;
							case 131:_imgsrc = dev131;break;
							case 167:_imgsrc = dev167;break;
							case 168:_imgsrc = dev168;break;
							case 169:_imgsrc = dev169;break;
							case 170:_imgsrc = dev168;break;
							case 171:_imgsrc = dev169;break;
						}
					_html += '<li attrid="'+ data.realDevList[j].code +'">';
						_html += '<img src="'+_imgsrc+'">';
						_html += '<div class="cls-div-msg-key ' + _state_color + '">';
							_html += '<div class="cls-div-msg-name">' +data.realDevList[j].name+'</div>';
							_html += '<div class="cls-div-msg-value">'+data.realDevList[j].value+'</div>' 
						_html += '</div>';

						_html += '<div class="cls-div-msg-state '+_state_color+'">' + _str_state + '</div>';
					_html += '</li>';
				}
				_html += '</ul>';
				
				$('#div_' + data.devId).html(_html);
				var me = this;
				$('#div_' + data.devId + ' li').click(function(){
					console.log('----', me.mapid, data.devId, $(this).attr('attrid'));
					me.$router.push({
						path: '/site',
						query: {
							siteId: me.mapid,
							devId: data.devId,
							attrId: $(this).attr('attrid')
						}
					});
				});
		},

		updateEntity(devId, state){
			//ss
			console.log(devId, state);
			var _entities = this.viewer.entities.values;
			_entities.forEach(function(item){
				if(item.id && item.id === devId){
					console.log('item', item);
					switch(state){
						case 0: item.billboard.image = pointImg0;break;
						case 1: item.billboard.image = pointImg1;break;
						case 2: item.billboard.image = pointImg2;break;
						case 3: item.billboard.image = pointImg3;break;
					}
				}
			});
			
		},

		render(data){
			for( var i in data){
				if(!data[i].x || !data[i].y){
					continue;
				}
				//var _dom = document.getElementById('div_'+data[i].devId);
				var geometry = Cesium.Cartesian3.fromDegrees(data[i].x, data[i].y, this.pointHight);
				var position = Cesium.SceneTransforms.wgs84ToWindowCoordinates(this.viewer.scene, geometry);
				// if(position&&_dom){
				// 	_dom.style.left = (position.x+20) + 'px';//+19
				// 	_dom.style.top = (position.y) + 'px';//-25
				// }
				if(position){
					data[i].left = (position.x+20) + 'px';
					data[i].top = (position.y) + 'px';
				}

			// _this.ctn.css("left",position.x- _this.ctn.get(0).offsetWidth/2);
			// _this.ctn.css("top",position.y- _this.ctn.get(0).offsetHeight - 10);
			}

			//video
			if(this.video_pick_entity){
				// var cartesian = this.viewer.camera.pickEllipsoid(this.video_pick_entity.position, this.viewer.scene.globe.ellipsoid);
				//console.log('******', this.video_pick_entity.position);
				var position1 = Cesium.SceneTransforms.wgs84ToWindowCoordinates(this.viewer.scene, this.video_pick_entity.position._value);
				this.video_left = (position1.x+20) + 'px';
				this.video_top =  (position1.y+50) + 'px';
			}
		},
		
		//video
		requestVideoList(){
			// var cpoint = this.getCenterPosition();
			// console.log(cpoint);
			// 生成测试用的坐标
			var tempx = 112.43665552914076, tempy = 30.00507789168641;
			console.log('****','this.dataRequest.devList.lenght ', this.dataRequest.devList.length);
			if(this.dataRequest.devList.length > 0){
				tempx = this.dataRequest.devList[0].x;
				tempy = this.dataRequest.devList[0].y;
			}
			//var tempx = cpoint.lon, tempy = cpoint.lat;
			listVideo({siteId: this.mapid}).then(res => {
				if(res.code != 200){
					return;
				}
				res.rows.forEach((item, index) => {
					if(!item.x){//没有坐标就给默认值
						item.x = tempx + (index+1)*0.0001;
						item.y = tempy + (index+1)*0.0001;
					}

					this.videoList.push(item);
					console.log(item, index);
					this.markerVideo(item, index);
				})
			});
		},

		markerVideo(item, index){
			var point = this.viewer.entities.add({
				id:item.id,
				name : item.name,
				position:Cesium.Cartesian3.fromDegrees(item.x,item.y, this.pointHight),
				ptype: 'video',
				pindex: index,
				billboard:{
					image: videoImg,
					width: 38,
					height: 50,
					scaleByDistance: new Cesium.NearFarScalar(100, 1.0, 1e4, 0.5)//,
					//scale: 1//,//0.6,
					//heightReference : Cesium.HeightReference.RELATIVE_TO_GROUND
				},
				label:{
					text: '监控-'+item.name,
					font:'14px sans-serif',
					style: Cesium.LabelStyle.FILL_AND_OUTLINE,
					fillColor: Cesium.Color.BLACK,
					backgroundColor: Cesium.Color.WHITE,
				//    clampToGround:false,
					//scale: 0.8,
					horizontalOrigin : Cesium.HorizontalOrigin.CENTER,
					verticalOrigin : Cesium.VerticalOrigin.BOTTOM,
					disableDepthTestDistance: 100.0,
					pixelOffset:new Cesium.Cartesian2(0, -30),
					//heightReference : Cesium.HeightReference.RELATIVE_TO_GROUND,
					showBackground:true
				}
			});
			
			//line
			var position1 = Cesium.Cartesian3.fromDegrees(item.x,item.y, this.pointHight);
			var position2 = Cesium.Cartesian3.fromDegrees(item.x,item.y,0);
			this.viewer.entities.add({
				polyline: {
					positions: [position1, position2],
					clampToGround: false,
					//material: Cesium.Color.RED,
					width: 1
				}
			});
			return point;
		},

		baiduMp4(mp4Url) {
		  console.log('--video--rtsp--', mp4Url); 
		  this.player = cyberplayer('id_video_play').setup({
            width: "100%", // 宽度，也可以支持百分比(不过父元素宽度要有)
            height: "100%", // 高度，也可以支持百分比
            title: "基本功能", // 标题
            file: mp4Url,
            image: "", // 预览图
            autostart: true, // 是否自动播放
            stretching: "uniform", // 拉伸设置
            repeat: false, // 是否重复播放
            volume: 100, // 音量
            controls: true, // controlbar是否显示
            starttime: 0, // 视频开始播放时间点(单位s)，如果不设置，则可以从上次播放时间点续播
			ak: "39f82ac87fc3462ea4dcc78734450f57" // 公有云平台注册即可获得accessKey
		  });
		},


		clear(){
			console.log("----清空三维对象----");
			if(this.intervalIOT){
				clearInterval(this.intervalIOT);
			}

			if(this.myEventListener){
				this.viewer.clock.onTick.removeEventListener(this.myEventListener);
				this.myEventListener = null;
			}
			
			$('.cls-div-tip').empty();
            //if(this.viewer.entities.length>0){
				this.viewer.entities.removeAll();//清空所有模型
			//}
			if(this.myPrimitive){
				this.viewer.scene.primitives.remove(this.myPrimitive);
				this.myPrimitive = null;
			}

			if(this.myImageryLayer){
				this.viewer.imageryLayers.remove(this.myImageryLayer);
				this.myImageryLayer = null;
			}

		}
		
	},

	watch:{
		'mapid':function(newVal,OLDval){
				console.log('new',newVal);
				this.mapid = newVal;
				this.loading = true;
				this.initScene();
			}
	},
	
	beforeDestroy() {
		//离开当前页面后执行
		console.log('离开当前页面后执行');
		this.clear();
		if(this.player){
			this.player.remove();
		}
	},

	destroyed() {
		this.$off();
		this.$destroy();
	}
}
</script>
<style lang='scss' scoped>
</style>
<style>
#cesiumContainer{height:100%; width:100%;overflow:hidden;position:relative;}
#id_div_title{position:absolute;top:0;left:0;width:100%;height:50px;background-color:black;color:white;opacity:0.5;}
#id_div_name{font-size:18px;line-height:46px;padding-left:10px;}

.cls-div-tip{position:absolute;z-index:100;border:0px solid #edffff;opacity:0.8;display:block;
	background-color:black;border-radius:5px}
.cls-tip-name{margin-bottom: 2px;background-color:black;padding:5px;text-align: center;
	border-top-left-radius:4px;border-top-right-radius:4px;border-bottom: 1px dashed #aaa;}
.cls-div-msg-name, .cls-div-msg-value{width:100px;text-align: left;font-size:10px;}
.cls-div-msg-state{float: left;height: 32px; line-height: 32px;font-size:12px;}
.cls-div-msg-key{float: left;}
.cls-ul-sblb{padding-left: 20px;}
.cls-ul-sblb li{margin:1px 1px 1px 5px;height: 35px;list-style: disc;padding:5px 10px; cursor: pointer;}
.cls-ul-sblb img{float: left;width: 20px;height: 20px; margin: 5px 12px 0 0;}
.cls-state-0{color: gray;}
.cls-state-1{color: white;}
.cls-state-2{color: orange;}
.cls-state-3{color: red;}
.iot-state-error{color: red;}
#id_video{position:absolute;z-index: 1000;bottom:10px;right:10px;width:400px;height:300px;
border:1px solid rgb(188, 194, 188);background-color: black;}
</style>
